import { useAppDispatch } from "app/hooks";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { setIsLoggedIn } from "reduxState/login/loginSlice";
import { getEnvVariable } from "utilities/env";
import { AuthContext } from "./AuthContext";

type Props = {
  children: React.ReactNode;
};

export function AuthProvider({ children }: Props) {
  const dispatch = useAppDispatch();
  const expirationHours = getEnvVariable("REACT_APP_COOKIE_EXPIRATION_HOURS");

  interface Tokens {
    admin_id_token: string;
    admin_refresh_token?: string;
  }
  const [token, setToken] = useState<Tokens>({
    admin_id_token: Cookies.get("admin_id_token") || "",
    admin_refresh_token: Cookies.get("admin_refresh_token") || "",
  });
  const updateToken = (
    admin_id_token: string,
    admin_refresh_token?: string,
  ) => {
    setToken({ admin_id_token, admin_refresh_token });
    Cookies.remove("admin_id_token");
    Cookies.remove("admin_refresh_token");

    const cookieOptions = {
      secure: true,
      expires: expirationHours
        ? new Date(Date.now() + parseInt(expirationHours) * 60 * 60 * 1000)
        : undefined,
    };
    if (admin_id_token) {
      dispatch(setIsLoggedIn(true));
      Cookies.set("admin_id_token", admin_id_token, cookieOptions);
    }
    if (admin_refresh_token) {
      Cookies.set("admin_refresh_token", admin_refresh_token, cookieOptions);
    }
  };
  return (
    <AuthContext.Provider
      value={{
        setToken: updateToken,
        tokens: token,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
